import { SWRConfig } from "swr";
// import useDashboardFilters from "../../hooks/useDashboardFilters";
import { DASHBOARD_ADMIN_SWR_CONFIG } from "../../utils/dashboardQueryKeys";
import adminClasses from "../AdminDashboardView/AdminDashboardView.module.css";
import SalesDashboardContent from "./SalesDashboardContent";
import SalesDashboardHeader from "./SalesDashboardHeader";
import useSalesDashboardData from "./useSalesDashboardData";

const SalesDashboardView = () => {
  // const filters = useDashboardFilters();
  const dashboard = useSalesDashboardData();

  return (
    <div className={adminClasses.page}>
      <SWRConfig value={DASHBOARD_ADMIN_SWR_CONFIG}>
        <SalesDashboardHeader />
        <div className={adminClasses.content}>
          <SalesDashboardContent dashboard={dashboard} />
        </div>
      </SWRConfig>
    </div>
  );
};

export default SalesDashboardView;
